import { Col, Form, Input, Select, InputNumber } from "antd";
import PhoneInput from "react-phone-input-2";
// import lang from "../helper/langHelper";
import "react-phone-input-2/lib/style.css";
import lang from "../helper/lang";

const PhoneNumberField = ({
  label,
  name,
  placeholder,
  cover,
  className,
  onChange,
  inputProps,
  colProps,
  countryCode,
  rules = true,
  mobileNumber,
  ...props
}) => {
  return (
    <Col md={cover ? cover.md : 12} {...colProps}>
      <Form.Item
        className=""
        label={label}
        name={name}
        rules={[
          {
            required: true,
            validator: (rule, value) => {
              if (!value) {
                return Promise.reject(lang("Please enter phone number"));
              }
              if (!/^\d{8,12}$/.test(mobileNumber?.mobile)) {
                return Promise.reject(
                  lang("Phone number must be between 8 and 12 digits")
                );
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <PhoneInput
          inputProps={{
            name: name,
            required: true,
            autoFocus: false,
            placeholder: placeholder,
            ...inputProps,
          }}
          isValid={(value, country) => {
            const countryCode = country.iso2;
            const number = value.slice(country?.dialCode?.length);
            if (countryCode === "il") {
              if (number && !/^5/.test(number))
                return "Number must start with number 5.";
              if (number && !/^972\d{9}$/.test(value))
                return "Number must be 9 digits.";
            }
            if (countryCode === "ps") {
              if (number && !/^5/.test(number))
                return "Number must start with number 5.";
              if (number && !/^970\d{9}$/.test(value))
                return "Number must be 9 digits";
            }

            if (!/^\d+$/.test(value)) {
              return "Invalid value: " + value;
            }
            return true;
          }}
          //value={}
          country={"kw"}
          countryCode={countryCode}
          preferredCountries={["in", "sa"]}
          onChange={onChange}
        />
      </Form.Item>
    </Col>
  );
};

export default PhoneNumberField;
